//
//
//
//
//
//

import cookie from "./utils/cookie";

export default {
  name: 'app',
  methods: {
      debug(ele,fn){
          var count = 0;
          var timeRange = 5000;
          var beginTime,time;
          const that = this;
          ele.addEventListener("click",function() {
              if(count == 0){
                  beginTime = new Date().getTime();
                  count ++;
              }else{
                  time = new Date().getTime();
                  if(time - beginTime >= timeRange){
                      if(count >= 20){
                          fn.call(that);
                          count = 0;
                      }else{
                          count = 0;
                          beginTime = null;
                      }
                  }else{
                      count ++;
                  }
              }
          },false);
      }
  },
  mounted() {
      window.dsBridge.register('changeSystemLang', lang => {
          if (['zh-CN', 'en-US', 'zh-TW'].includes(lang)) {
              this.$i18n.locale = lang;
              cookie.set("lang", lang);
              window.location.reload();
          }
      });
      this.debug(document, () => {
          if(this.$config.env !== 'prod') {
              this.$vux.toast.show({
                  text: "已启用调试模式",
                  type: "text",
                  onHide: () => {
                      this.$router.push({name: 'test'});
                  }
              });
          }
      });
  }
}



// WEBPACK FOOTER //
// ./src/App.vue